import { all } from 'redux-saga/effects';
import authSagas from './auth/saga';
import specialitySagas from './speciality/saga';

export default function* rootSaga(getState) {
  yield all([authSagas(), specialitySagas()]);
}
